<template>
  <section class="vh-75 mt-3">
    <div class="container-fluid h-custom">
      <div class="row d-flex justify-content-center align-items-center h-75">
        <div class="col-md-9 col-lg-6 col-xl-5 mb-4 mb-lg-0">
          <img src="../assets/images/about-us/homeplus.jpg" class="img-fluid rounded-4" alt="Sample image" />
        </div>
        <div class="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
          <div class="alert alert-danger alert-dismissible fade show" role="alert"
            v-if="Object.keys(errors).length > 0">
            <ul>
              <li v-for="(error, index) in errors" :key="index">
                {{ error.join(' - ') }}
              </li>
              <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
            </ul>
          </div>
          <div v-if="message">
            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="message !== ''">
              {{ message }}
              <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
            </div>
          </div>
          <template v-if="!isSentCode">
            <form @submit.prevent="signIn">
              <div class="form-outline mb-4">
                <label class="form-label fw-bold mb-5" for="form3Example4">شمارهٔ موبایل خود را وارد کنید</label>
                <input autocomplete="off" type="tel" v-mask="'#### ### ####'" v-model="phone" id="form3Example4"
                  class="form-control form-control-lg" placeholder="09XXXXXXXXX" />
              </div>
              <div class="text-center text-lg-start mt-4 pt-2">
                <button type="submit" class="btn btn-success btn-lg"
                  style="padding-left: 2.5rem; padding-right: 2.5rem">
                  ارسال کد
                </button>
              </div>
            </form>
          </template>
          <template v-if="isSentCode">
            <form @submit.prevent="getToken">
              <div class="form-outline mb-4">
                <label class="form-label fw-bold mb-5" for="form3Example4">کد تأیید را وارد کنید</label>
                <input autocomplete="off" v-model="code" type="tel" v-mask="'# # # #'" id="form3Example4"
                  class="form-control form-control-lg" placeholder="کد تایید 4 رقمی" />
              </div>
              <div class="text-center text-lg-start mt-4 pt-2">
                <button @click="getToken" type="submit" class="btn btn-success btn-lg"
                  style="padding-left: 2.5rem; padding-right: 2.5rem">
                  ورود
                </button>
              </div>
            </form>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  name: "Login",
  data() {
    return {
      isSentCode: false,
      phone: null,
      code: null,
      errors: {},
      message: ''
    };
  },
  directives: { mask },
  methods: {
    signIn() {
      this.errors = {}
      this.message = ''
      this.axios
        .post("https://api.amlakplus.app/v1/user/auth/sign-in", {
          phone: this.phone.replaceAll(" ", ""),
        })
        .then((res) => {
          if (res.status === 200) {
            this.isSentCode = true;
          }
        })
        .catch(error => {
          this.errors = error.response.data.errors
          this.message = error.response.data.message
        });
    },
    getToken() {
      this.errors = {}
      this.message = ''
      this.axios
        .post("https://api.amlakplus.app/v1/user/auth/get-token", {
          phone: this.phone.replaceAll(" ", ""),
          code: this.code.replaceAll(" ", ""),
          device_name: "BROWSER",
          os: "WEB",
        })
        .then((res) => {
          if (res.status === 200) {
            window.localStorage.setItem("token", res.data.data.token);
            window.localStorage.setItem("isAuthenticated", true);
            this.$store.commit("login", res.data.data.token);
            this.$router.push("/aboutus");
          }
        })
        .catch(error => {
          if (error.response.status === 400) {
            this.message = error.response.data.message;
          } else if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
          // this.errors = error.response.data.errors
          // this.message = error.response.data.message
        });
    },
  },
};
</script>
